import PropTypes from 'prop-types';
import React from 'react';
import Search from '../../../containers/homepage/search-widget';

const Overlay = ({region, heroOptions}) => {
  let classes = ['hero-overlay'];
  const heroMessage = heroOptions.showHeroMessage && heroOptions.heroMessage ?
    <h1>{heroOptions.heroMessage}</h1> :
    null;
  if (heroOptions.searchBarPlacement === 'BOTTOM') classes.push('bottom');

  return (
    <div className={classes.join(' ')}>
      <div className="overlay-inner">
        {heroMessage}
        <Search region={region} show={heroOptions.showSearchBar}/>
      </div>
    </div>
  );
};

Overlay.propTypes = {
  heroOptions: PropTypes.object.isRequired,
  region: PropTypes.string.isRequired
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/overlay.js